module.exports = __webpack_public_path__ + "static/media/Laura.9eee6770.jpg";